import { render, staticRenderFns } from "./questionType.vue?vue&type=template&id=c4b26cd4&scoped=true&"
import script from "./questionType.vue?vue&type=script&lang=ts&"
export * from "./questionType.vue?vue&type=script&lang=ts&"
import style0 from "./questionType.vue?vue&type=style&index=0&lang=css&"
import style1 from "./questionType.vue?vue&type=style&index=1&id=c4b26cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b26cd4",
  null
  
)

export default component.exports